import FnbPOS from "./FnbPOS";
export default function FnbRoomServicePage() {
  return <FnbPOS serviceKind="room_service" showTables={false} showRoomInput testidPrefix="rs"/>;
}
